import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}delivery-documentation`;
function token() {
  return localStorage.getItem("auth-token");
}
export async function request(path, options = {}) {
  const isFormData = options.body instanceof FormData;
  const headers = {
    Authorization: `Bearer ${token()}`,
    ...(isFormData
      ? {}
      : { "Content-Type": "application/json" }),
    ...options.headers,
  };
  const response = await fetch(`${BASE}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || data.error || "تعذر إكمال الطلب");
    error.status = response.status;
    error.code = data.code;
    error.unsupported = data.unsupported;
    error.malformed = data.malformed;
    error.validationWarnings = data.validationWarnings;
    throw error;
  }
  return data;
}
export async function downloadRequest(path, body = {}) {
  const response = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const contentType = response.headers.get("content-type") || "";
  if (!response.ok) {
    const data = contentType.includes("application/json")
      ? await response.json().catch(() => ({}))
      : {};
    const error = new Error(data.message || data.error || "تعذر إنشاء التصدير");
    error.status = response.status;
    error.code = data.code;
    error.count = data.count;
    error.limit = data.limit;
    throw error;
  }
  const disposition = response.headers.get("content-disposition") || "";
  return {
    blob: await response.blob(),
    filename: filenameFromContentDisposition(disposition),
  };
}
export function filenameFromContentDisposition(disposition = "") {
  const utf8Match = disposition.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ""));
  }
  const filenameMatch = disposition.match(/filename\s*=\s*("?)([^";]+)\1/i);
  return filenameMatch?.[2]?.trim() || "";
}
export function ensureExcelFilename(fileName, fallback = "objection-report.xlsx") {
  const value = String(fileName || fallback).trim() || fallback;
  return value.toLowerCase().endsWith(".xlsx") ? value : `${value}.xlsx`;
}
export async function downloadGeneratedDisputeExcel(id) {
  const response = await fetch(`${BASE}/admin/disputes/${id}/excel`, {
    headers: { Authorization: `Bearer ${token()}` },
  });
  const contentType = response.headers.get("content-type") || "";
  if (!response.ok) {
    const data = contentType.includes("application/json")
      ? await response.json().catch(() => ({}))
      : {};
    const error = new Error(data.message || data.error || "تعذر تحميل ملف Excel");
    error.status = response.status;
    error.code = data.code;
    throw error;
  }
  return {
    blob: await response.blob(),
    filename: ensureExcelFilename(
      filenameFromContentDisposition(response.headers.get("content-disposition") || ""),
    ),
  };
}
const query = (params) =>
  `?${new URLSearchParams(Object.entries(params).filter(([key, value]) => key !== "signal" && value !== "" && value != null)).toString()}`;
export const getDeliveryDocumentationContext = () => request("/context");
export const getCashierSummary = (params = {}) =>
  request(`/cashier/summary${query(params)}`);
export const getAdminDocumentationSummary = (params = {}) =>
  request(`/admin/summary${query(params)}`);
export const getAdminHierarchyRestaurants = (params = {}) =>
  request(`/admin/hierarchy/restaurants${query(params)}`);
export const getAdminHierarchyBranches = (storeId, params = {}) =>
  request(`/admin/hierarchy/restaurants/${storeId}/branches${query(params)}`);
export const getAdminHierarchyApplications = (branchId, params = {}) =>
  request(`/admin/hierarchy/branches/${branchId}/applications${query(params)}`);
export const getAdminHierarchyMonths = (applicationId, params = {}) =>
  request(`/admin/hierarchy/applications/${applicationId}/months${query(params)}`);
export const getAdminHierarchyDays = (applicationId, month, params = {}) =>
  request(`/admin/hierarchy/applications/${applicationId}/months/${month}/days${query(params)}`);
export const getAdminDocumentationOrders = (params = {}) =>
  request(`/admin/orders${query(params)}`);
export const getAdminDocumentationOrder = (orderId) =>
  request(`/admin/orders/${orderId}`);
export const getAdminDocumentationOrderHistory = (orderId) =>
  request(`/admin/orders/${orderId}/history`);
export const getAdminDeletedOrders = (params = {}) =>
  request(`/admin/deleted-orders${query(params)}`);
export const getAdminAuditLog = (params = {}) =>
  request(`/admin/audit-log${query(params)}`);
export const getAdminCompensationDisputeCandidates = (params = {}) =>
  request(`/admin/dispute-candidates${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputes = (params = {}) =>
  request(`/admin/disputes${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputeSummary = (params = {}) =>
  request(`/admin/disputes/summary${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputeRestaurants = (params = {}) =>
  request(`/admin/disputes/filter-options/restaurants${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputeBranches = (params = {}) =>
  request(`/admin/disputes/filter-options/branches${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputeApplications = (params = {}) =>
  request(`/admin/disputes/filter-options/applications${query(params)}`, params.signal ? { signal: params.signal } : {});
export const getAdminDisputeDetails = (id) =>
  request(`/admin/disputes/${id}/details`);
export const createAdminDisputeReadinessException = (data) =>
  request("/admin/dispute-readiness-exceptions", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const createAndSendAdminDispute = (rowIds, options = {}) =>
  request("/admin/disputes/create-and-send", {
    method: "POST",
    body: JSON.stringify({ rowIds, ...options }),
  });
export const getAdminDispute = (id) => request(`/admin/disputes/${id}`);
export const generateAdminDispute = (id) =>
  request(`/admin/disputes/${id}/generate`, { method: "POST" });
export const sendAdminDispute = (id, options = {}) =>
  request(`/admin/disputes/${id}/send`, {
    method: "POST",
    body: JSON.stringify(options),
  });
export const getAdminDisputeSettings = () =>
  request("/admin/dispute-settings");
export const updateAdminDisputeSettings = (applicationKey, data) =>
  request(`/admin/dispute-settings/${encodeURIComponent(applicationKey)}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
export const exportAdminExcel = (filters = {}) =>
  downloadRequest("/admin/exports/excel", filters);
export const exportAdminPhotosZip = (filters = {}) =>
  downloadRequest("/admin/exports/photos-zip", filters);
export const getDocumentationOrders = (params) =>
  request(`/orders${query(params)}`);
export const createDocumentationOrder = (data) =>
  request("/orders", { method: "POST", body: JSON.stringify(data) });
export const addDocumentationConclusion = (id, data) =>
  request(`/orders/${id}/conclusions`, {
    method: "POST",
    body: JSON.stringify(data),
  });
export const addDocumentationNote = (id, data) =>
  request(`/orders/${id}/notes`, {
    method: "POST",
    body: JSON.stringify(data),
  });
export const revertDocumentationConclusion = (id, conclusionId) =>
  request(`/orders/${id}/conclusions/${conclusionId}/revert`, {
    method: "POST",
  });
export function uploadEvidence(id, type, file, replace = false) {
  if (!(file instanceof Blob)) {
    return Promise.reject(new TypeError("A captured image File or Blob is required"));
  }
  const body = new FormData();
  body.append("file", file, file.name || `evidence-${Date.now()}.jpg`);
  body.append("capturedAt", new Date(file.lastModified || Date.now()).toISOString());
  return request(`/orders/${id}/evidence/${type}`, {
    method: replace ? "PUT" : "POST",
    body,
  }).then((data) => {
    if (!data?.success || !data?.order || !data?.evidence) {
      throw new Error("لم يُرجع الخادم بيانات التوثيق المحدثة");
    }
    return data;
  });
}
export const deleteEvidence = (id, type, reason) =>
  request(`/orders/${id}/evidence/${type}`, {
    method: "DELETE",
    body: JSON.stringify({ reason }),
  });
export const deleteDocumentationOrder = (id, reason) =>
  request(`/orders/${id}`, {
    method: "DELETE",
    body: JSON.stringify({ reason }),
  });
